<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Programación de Inducciones</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Programación de Inducciones</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <app-induccion-filtros-busqueda [modelFilter]="modelFilter" [displayFechaAprobacion]="true" [displayFechaInduccion]="false"></app-induccion-filtros-busqueda>

      </div>
      
    </div>
    
    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            
            <a class="btn btn-naranja" mat-raised-button (click)="programar()" [disabled]="esInvalido()"><mat-icon>calendar_today</mat-icon> Programar</a>
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon> Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="modelListaInducciones"
          class="table table-striped table-vcenter"
        >

        <ng-container matColumnDef="compania">
          <th mat-header-cell *matHeaderCellDef>Compañía</th>
          <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
        </ng-container>
        
          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.nombres }} {{ element.apellidoPaterno }}
              {{ element.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro. Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.nroDocumentoIdentidad }}
            </td>
          </ng-container>
          

          <ng-container matColumnDef="fecha_aprobacion">
            <th mat-header-cell *matHeaderCellDef>Aprobación de Documentos</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.solicitud.fechaAprobacionRechazo | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado de Inducción</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.sede.nombre }}</td>
          </ng-container>

          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">{{ element.solicitud.solicitante }}</td>
          </ng-container>

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">
              {{ element.solicitud.contratista.nombre }}
            </td>
          </ng-container>

          <ng-container matColumnDef="codigo_solicitud">
            <th mat-header-cell *matHeaderCellDef>Codigo Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.solicitud.codigo }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [(ngModel)]="element.programarInduccion" *ngIf="element.idEstado == 1 || element.idEstado == 4" ></mat-checkbox>

              <!-- <button
                mat-icon-button
                color="primary"
                (click)="openDialog(element)"
                aria-label="Programar"
              >
                <mat-icon>remove_red_eye</mat-icon>
              </button>               -->
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          #paginator
          [length]="resultsLength"
          [pageSize]="30"
          (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>

<!-- <pre>{{ modelListaInducciones | json }}</pre> -->
